import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GanttDate, GanttItem, GanttViewOptions, startOfDay } from '@worktile/gantt';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { find, firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getAsignacionesInst, getCuestionarioPorId, getEstatusHoja, getHojaRespuesta } from '../../../services/Administrador/cuestionarios/query';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

import $, { get } from 'jquery';
import moment from 'moment';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isArray } from '@apollo/client/utilities';
import { functionsFormat, functionsGoals, obtenerTamMax, optencionPeriodos } from '../../../models/Cuestionarios/funciones';
import { getActivities, getOnlyProjects, getProyectos } from '../../../services/proyectos/querys';
import { ProjectsService } from '../../../services/proyectos/projects.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { MatMenuTrigger } from '@angular/material/menu';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import { FiltersM } from '../../../components/models';

@Component({
  selector: 'app-seguimiento-plan',
  templateUrl: './seguimiento-plan.component.html',
  styleUrl: './seguimiento-plan.component.css'
})
export class SeguimientoPlanComponent {
  Filters = FiltersM;
  /* variables */  
  public allocations = [];
  public allocationId = undefined;
  public dataOrdenado = [];

  /** Verdadero si todos los proyectos están desplegados; el icono del encabezado los despliega o los pliega a la vez */
  public get todosVisibles(): boolean {
    return this.dataOrdenado.length > 0 && this.dataOrdenado.every(p => p.visible);
  }
  public alternarTodos(): void {
    const mostrar = !this.todosVisibles;
    this.dataOrdenado.forEach(p => p.visible = mostrar);
  }
  public periodos = [];
  public responsibles = [];
  public aditionals = [];
  public viewTablero = false;
  public viewResponsables = [];
  public viewResponsablesActivity = [];
  public viewAllresponsibles = true;
  public viewAllresponsiblesActivity = true;

  public allocation = [];
  private answersSheet = [];
  public questionsForPlans = [];

  public prefix = '';
  public suffix = '';
  public miles = ',';
  public decimal = '.';
  public precicion = 0;
  public aling = '';

  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition = { x: '0', y: '0' };
  private adDelete: any;

  proyects = [];
  activities: any[] = [];

  public estats = [
    {name: 'Reprogramada', check: true},
    {name: 'Cumplida', check: true},
    {name: 'Incumplida', check: true},
    {name: 'En proceso', check: true},
    {name: 'No iniciada', check: true},
  ];

  constructor(
    public dataService: DataService,
    private route: Router,
    private cookieService: CookieService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private service: ProjectsService,
    private excel: ExcelService,
  ){
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
    setTimeout(() => {
      // this.getAllocations();
      this.getData();
    }, 100);
  }
  /* Escribir información */
  public printDate(date){
    return moment(date).format('MMM-YY')
  }
  /* obtener tabla */
  private async getData(){
    this.activities = [];
    
    // En clima-laboral no se guarda 'answers' en localStorage: leerlo dejaría
    // answersSheet en null y structureQuestions reventaría al hacer .find().
    // Se queda como arreglo vacío y la ponderación cae a 0, igual que en plan-accion.
    // this.answersSheet = JSON.parse(localStorage.getItem('answers'));
    this.allocation = JSON.parse(localStorage.getItem('allocation'));
    this.allocationId = this.allocation ? this.allocation['id'] : undefined;
    const cuestionario = JSON.parse(localStorage.getItem('cuestionario'));

    const responsables = await this.service.getResponsables(this.allocation['institution_id']);
    this.responsibles = responsables.map( r =>( {...r}));
    this.ListelementosCategories(cuestionario.categories, null);

    const data = await this.service.getProjects();

    var startDay = undefined, endDay = undefined;
    var proAux = [];
    for( const dat of data.projects){
      const ex = this.questionsForPlans.find( d => Number(d.id) === Number(dat.question.id));
      // El tablero se rige por la asignación elegida en el módulo: solo entran
      // los proyectos de esa allocation, igual que en plan-accion.
      const matchesAllocation = Number(dat.allocationId) === Number(this.allocationId);
      if(ex && matchesAllocation){
        const ex = await this.service.getActivities(dat.id);

        if (ex.length !== 0) {
          const dates = this.getActivities(ex, dat);
          this.activities = this.activities.concat(dates[2]);
          proAux.push({
            name: dat.name,
            questionId: dat.question.id,
            id: dat.id,
            start_date: dates[0],
            end_date: dates[1],
            days: moment(dates[1]).diff( moment(dates[0]), 'days' )+1,
            goals: functionsGoals.getGoals( dates[0], dates[1], dat.id ),
            visible: true,
            adicionales: dat.adicionales,
            responsable: dat.responsible,
          });

          if( startDay === undefined || moment(dates[0]).isBefore( moment(startDay) ) ){
            startDay = dates[0];
          }
          if( endDay === undefined || moment(dates[1]).isAfter( moment(endDay) ) ){
            endDay = dates[1];
          }
        }
      }
    }
    this.periodos = optencionPeriodos.getPeriodos(startDay, endDay);
    this.proyects = proAux;
    // Al filtrar por allocation la lista puede quedar vacía (asignación sin
    // proyectos), así que no se asume que exista el primero.
    this.aditionals = this.proyects.length ? this.proyects[0].adicionales : [];
    this.viewTablero = true;
    this.getShowProjects(true, true);
  }
  private getActivities(ex, dat){
    var startDay = undefined;
    var endDay = undefined;
    var aux = [];
    for( const act of ex ){
      var progressAct = [];
      if(act.progress && act.progress.length !== 0){
        for(const progress of act.progress){
          const p = {
            planned: Number(progress.planned),
            executed: Number(progress.executed),
            periodo: moment(`${progress.year}-${progress.month}`, 'YYYY-MM').format('MMM-YY').toLowerCase(),
            year: progress.year,
            month: progress.month,
            id: progress.id,
            activitieId: act.id,
          }
          progressAct.push(p);
        }
      }
      const goals = functionsGoals.getGoals( act.start_date, act.due_date, act.id );
      
      for(const goal of goals){
        const ex = progressAct.find(g => g.periodo === goal.periodo);
        if ( !ex ){
          progressAct.push(goal);
        }
      }

      const merge = [ ...progressAct, ...goals ];
      progressAct = Object.values( merge.reduce((acc, current) => {
        const key = `${current.periodo}-${current.year}-${current.month}`;
        if (!acc[key] || (current.executed !== null && acc[key].executed === null)) {
          acc[key] = current;
        }
        return acc;
      }, {}));

      var finalizada = false;
      if(progressAct.find(g => g.executed === 100)){
        finalizada = true;
      }
      aux.push({
        name: act.name,
        start_date: act.start_date.split('T')[0],
        end_date: act.due_date.split('T')[0],
        days: moment(act.due_date.split('T')[0]).diff( moment(act.start_date.split('T')[0]), 'days')+1,
        id: act.id,
        idProyect: dat.id,
        goals: progressAct,
        finalizada: finalizada,
        adicionales: act.adicionales,
        responsable: act.responsible,
      });

      if( startDay === undefined || moment(act.start_date.split('T')[0]).isBefore( moment(startDay) ) ){
        startDay = act.start_date.split('T')[0];
      }
      if( endDay === undefined || moment(act.due_date.split('T')[0]).isAfter( moment(endDay) ) ){
        endDay = act.due_date.split('T')[0];
      }
    }

    return [ startDay, endDay, aux ]
  }
  private getShowProjects(calcRes?, calcResAct?){
    var aux = [];
    this.dataOrdenado = [];
    for(const proy of this.proyects){
      var auxAct = [];
      const ex = this.activities.filter(a => a.idProyect === proy.id);
      for(const act of ex){
        if(this.isVisible(act)){
          auxAct.push(act);       
        }
      }
      if(auxAct.length !== 0){
        var responsable = false;
        if(this.viewAllresponsibles){
          responsable = true;
        }else{
          const ex = this.viewResponsables.find(pl => pl.id === proy.responsable?.id);
          responsable = ex?.check??false;
        }
        
        if(responsable){
          aux.push(
            {...JSON.parse(JSON.stringify(proy)), activities: JSON.parse(JSON.stringify(auxAct))}
          );
        }
      }
    }
    this.dataOrdenado = aux;
    if(calcRes){
      var auxRes = [];
      this.dataOrdenado.forEach(p =>{
        const ex = auxRes.find( r => r.id === p.responsable?.id);
        if(!ex && p.responsable){
          auxRes.push({
            ...p.responsable,
            name: p.responsable.role_name,
            check: false,
          });
        }
      });

      this.viewResponsables = auxRes;
    }
    if(calcResAct){
      var auxResActi = [];
      this.dataOrdenado.forEach(p => {
        p.activities.forEach( a => {
          const ex = auxResActi.find( r => r.id === a.responsable?.id);
          if(!ex && a.responsable){
            auxResActi.push({
              ...a.responsable,
              name: a.responsable.role_name,
              check: false,
            });
          }
        });
      });
      this.viewResponsablesActivity = auxResActi;
    }


    this.previewProject();
  }
  private ListelementosCategories(elements, id){
    for(const e of elements){
      const quest = this.structureQuestions(e.questions);
      this.questionsForPlans = this.questionsForPlans.concat(quest);
    }
  }
  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          respuesta: r.description,
          score: r.score,
        });
      }
      const answer = this.answersSheet.find(c => c.idQuestion === q.id);
      var valor = 0;

      try{
        valor = res.find(c => c.id === answer.idAnswer).score*10/10;
      }catch(err){
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        ponderacion: valor,
      });
    }

    return newQuestions;
  }
  /* Visibilidad actividades proyectos */
  public isVisible( item: any){
    const per = this.getPeriod();
    const p = moment(per, 'MMM-YY');
    
    const start = moment(item.start_date);
    const end = moment(item.end_date);

    var periodo = false;

    if( p.isBetween(start, end, 'month', '[]') || ( !item.finalizada && end.isBefore(p) ) || (item.goals.find(p => p.periodo === per)) ){
      periodo = true;
    }

    var responsable = false;
    if(this.viewAllresponsiblesActivity){
      responsable = true;
    }else{
      const ex = this.viewResponsablesActivity.find(pl => pl.id === item.responsable?.id);
      responsable = ex?.check??false;
    }

    return periodo && responsable;
  }
  /* Optención de la meta */
  public getGoal(goals: any[]){
    const per = this.getPeriod();

    if( goals !== undefined && goals.length > 0 ){
      const ex = goals.find( c => c.periodo === per);
      if( ex !== undefined ){        
        return ex;
      }
    }
    const date = moment(per, 'MMM-YY')
    goals.push({
      planned: 100,
      executed: null,
      periodo: per,
      year: date.year(),
      month: date.month()+1,
      id: '',
      activitieId: goals[0].activitieId,
    });

    // this.previewProject();
  }
  /* Avance de metas */
  public async previewGoal(goals: any[], activitie){
    const g = this.getGoal(goals);

    let guardo = false, introdujo: any;
    introdujo = await Swal.fire({
      title: ''+ this.translate.instant('cues.planes-seguimiento.avance'),
      text: "",
      input: 'number',
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      inputValue: g !== undefined ? g.executed : '',
      confirmButtonText: this.translate.instant('acciones.acep'),
      cancelButtonText: this.translate.instant('acciones.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {

        if( Number(value) >= 100 && g.planned !== 100 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance');
        }
        if( Number(value) > 100 && g.planned === 100 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance-correcto');
        }
        if( Number(value) < 0 ){
          return this.translate.instant('cues.planes-seguimiento.ingresar-avance-positivo');
        }

        guardo = true;
        return '';
      }
    });

    if( guardo ){
      
      if(g.id !== ''){
        if(Number(introdujo.value) === 0){
          try{
            const res = await firstValueFrom(
              this.service.deleteProgress(g.id)
            );
            g.id = '';
            g.executed = null;
          }catch(error){
            Swal.close();
            messages.errorMessageGraph(error.error.message);
            return;
          }
        }else{
          try{
            g.executed = Number(introdujo.value);
            const res = await firstValueFrom(
              this.service.patchProgress(g)
            );
          }catch(error){
            Swal.close();
            messages.errorMessageGraph(error.error.message);
            return;
          }
        }
      }else{
        try{
          g.executed = Number(introdujo.value);
          const prog = await firstValueFrom(
            this.service.postProgress(g)
          );
          g.id = prog['data'].id;
          const ex = this.activities.find(c => c.id === g.activitieId);
          const exGoal = ex.goals.find(m => m.periodo === g.periodo);
          if(!exGoal){
            ex.goals.push(g)
          }
        }catch(error){
          Swal.close();
          messages.errorMessageGraph(error.error.message);
        }
      }

      if(goals.find(g => g.executed === 100)){
        activitie.finalizada = true;
      }else{
        activitie.finalizada = false;
      }
      const f = this.activities.find(e => e.id === activitie.id);
      f.finalizada = activitie.finalizada;
      const m = activitie.goals.filter(m => m.id !== null);
      f.goals = m;

      this.previewProject();
    }
    
  }
  /* Avance de los proyectos */
  private previewProject(){
    const per = this.getPeriod();

    for(const p of this.dataOrdenado){
      var avance = 0;
      var actTot = 0;

      for(const a of p.activities){
        const g = this.getGoal(a.goals);
        if(!g) continue;
        avance += Number((g.executed * 100 / g.planned).toFixed(2));
        actTot ++;
      }

      const gP = this.getGoal(p.goals);
      if(gP){
        avance = Number( (avance / actTot).toFixed(2) );
        avance = Number( (avance * gP.planned / 100).toFixed(2) );
        
        gP.executed = avance;
      }
    }
  }
  /* Optención del periodo */
  private getPeriod(otro?){
    for(const p of this.periodos){
      for(const s of p.series){
        if( s.check ){
          if(otro){
            return `${s.me}-${s.an}`
          }
          return s.periodo;
        }
      }
    }
    return undefined;
  }
  /* Periodos */
  public writePeriods(periodo){
    const p = periodo.split('-');

    const m = this.translate.instant( 'filtros.'+p[0] );

    return m + '-' + p[1];
  }
  public changePeriods(periodo){
    this.periodos.forEach( p => {
      p.series.forEach( s => {
        if( s.periodo === periodo.periodo ){
          s.check = true;
        }else{
          s.check = false;
        }
      });
    });
    this.getShowProjects();
  }
  public changeResponsibles(responsible){
    this.viewAllresponsiblesActivity = true;
    if(responsible === 'consolidado'){
      this.viewAllresponsibles = !this.viewAllresponsibles;

      if(!this.viewAllresponsibles){
        var auxResActi = [];
        this.dataOrdenado.forEach(p => {
          p.activities.forEach( a => {
            const ex = auxResActi.find( r => r.id === a.responsable?.id);
            if(!ex && a.responsable){
              auxResActi.push({
                ...a.responsable,
                name: a.responsable.role_name,
                check: false,
              });
            }
          });
        });
        this.viewResponsablesActivity = auxResActi;
        return;
      }else{
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsables.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsables.some( r => r.check === false);
      if(!c){
        this.viewAllresponsibles = true;
        this.viewResponsables.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getShowProjects(false, true);
  }
  public changeResponsiblesActivity(responsible){
    if(responsible === 'consolidado'){
      this.viewAllresponsiblesActivity = !this.viewAllresponsiblesActivity;

      if(!this.viewAllresponsiblesActivity){
        return;
      }else{
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }else{
      this.viewResponsablesActivity.forEach( r =>{
        r.id === responsible.id ? r.check = !r.check: '';
      });

      const c = this.viewResponsablesActivity.some( r => r.check === false);
      if(!c){
        this.viewAllresponsiblesActivity = true;
        this.viewResponsablesActivity.forEach( r =>{
          r.check = false;
        });
      }
    }
    this.getShowProjects();
  }
  /** */
  borrarFiltro(){
    this.viewTablero = false;
    this.viewAllresponsibles = true;
    this.viewAllresponsiblesActivity = true;
    this.getData();
  }
  // Comentarios
  public getComent(ad, act){
    const per = this.getPeriod();
    const adit = act.aditional.find(c => c.name === ad.name && c.type === ad.type);
    const com = adit.coments.find( c => c.periodo === per);
    if(com){
      return com.coment;
    }
    
    return '';
  }
  // Archivos
  /** Exporta la tabla hasta el acumulado: proyectos y actividades con responsable, fechas, estatus, planeado, ejecutado y acumulado */
  public excelExport(){
    var headers = [
      this.translate.instant('cues.planes-seguimiento.proyectos'),
      this.translate.instant('cues.proyectos.selec-responsible'),
      this.translate.instant('cues.planes-seguimiento.inicio'),
      this.translate.instant('cues.planes-seguimiento.dias'),
      this.translate.instant('cues.planes-seguimiento.fin'),
      this.translate.instant('cues.planes-seguimiento.estatus'),
      this.translate.instant('cues.planes-seguimiento.planeado-pct'),
      this.translate.instant('cues.planes-seguimiento.ejecutado-pct'),
      this.translate.instant('cues.planes-seguimiento.acumulado-pct'),
    ];
    // Estatus, planeado, ejecutado y acumulado van centrados
    const alineaciones = ['left', 'left', 'left', 'left', 'left', 'center', 'center', 'center', 'center'];
    const columnaEjecutado = 7;
    var data = [];
    var colores = [];
    const array = this.getAllProyects();
    for(const p of array){
      const meta = this.getGoal(p.goals);
      data.push([
        p.name,
        p.responsable?.role_name ?? '',
        p.start_date,
        p.days,
        p.end_date,
        '',
        meta?.planned ?? '',
        meta?.executed ?? 0,
        '',
      ]);
      colores.push(headers.map(() => ''));
      for(const a of p.activities){
        const metaA = this.getGoal(a.goals);
        data.push([
          `-${a.name}`,
          a.responsable?.role_name ?? '',
          a.start_date,
          a.days,
          a.end_date,
          this.getEstatus(a),
          metaA?.planned ?? '',
          metaA?.executed ?? '',
          this.getAcumulado(a),
        ]);
        // Barra de color del estatus en la celda de ejecutado, como en la tabla
        colores.push(headers.map((_, col) => col === columnaEjecutado ? this.getEstatus(a, 'c') : ''));
      }
    }
    this.excel.generateTableSeguimientoPlanes(
      this.translate.instant(`menu.${this.dataService.moduleSelect}`),
      headers,
      data,
      this.translate.instant(`menu.${this.dataService.moduleSelect}`),
      alineaciones,
      colores
    );
  }
  private getAllProyects(){
    var array = [];

    for(const pr of this.proyects){
      const act = JSON.parse(JSON.stringify(this.activities.filter(a => a.idProyect === pr.id)));
      for(const a of act){
        const acum = Math.max(...a.goals.map( m => m.executed));
        a['acumulado'] = acum;
      }
      const p = {
        ...pr,
        activities: act
      }
      array.push(p)
    }

    return array;
  }
  /* Estatus */
  public getEstatus(item, col?){
    const g = this.getGoal(item.goals);

    if(!g) return '';
    if(g.executed === null){
      if(col){
        return '#C8C7C8'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-1');
    }

    const rend = Number( (g.executed*100/g.planned).toFixed(2) );
    if(rend <= 80){
      if(col){
        return '#FFD100'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-2');
    }
    if(rend >= 80 ){
      if(col){
        return '#72D54A'
      }
      return this.translate.instant('cues.planes-seguimiento.estatus-3');
    }

  }
  /* Acumulado */
  public getAcumulado(a){
    const per = moment(this.getPeriod(), 'MMM-YY');
    const metasFin = a.goals.filter(m => moment(m.periodo, 'MMM-YY').isSameOrBefore(per));
    return Math.max(...metasFin.map( m => m.executed));    
  }
  /** escribir adicionales */
  public writeAditional(additional, activitie, object?){
    const ex = activitie.adicionales.find(a => a.nombre === additional.nombre);
    const per =  moment(this.getPeriod('numeros'), 'MM-YYYY').format('YYYY-MM-DD');
    switch(additional.tipo){
      case 'TEXT':
        if(ex){
          const com = ex.comentarios.find(c => moment(c.date.split('T')[0]).format('YYYY-MM-DD') === per );
          if( object && com ){
            return com;
          }
          return com?.comentario;
        }        
        break;
      case 'FILE':
        if(ex){
          const fil = ex.archivos.find(c => moment(c.date.split('T')[0]).format('YYYY-MM-DD') === per );
          if( object && fil ){
            return fil;
          }
          return fil?.nombre;
        }    
        break;
    }
    return undefined;
  }
  public async editAditional(additional, activitie){
    var guardo = false;
    const configArray = {
      TEXT: {
        input: 'text',
        title: this.translate.instant('gestion.seguimiento.proy-estra.ingComen'),
        getValue: () => this.writeAditional(additional, activitie),
        validator: () => {
          guardo = true;
          return '';
        }
      },
      FILE: {
        input: 'file',
        title: this.translate.instant('gestion.seguimiento.proy-estra.selecArch'),
        getValue: () => this.writeAditional(additional, activitie),
        validator: (value) => {
          if (!value) {
            return this.translate.instant('gestion.seguimiento.proy-estra.datoInvalido');
          }
          guardo = true;
          return '';
        }
      }
    };

    const config = configArray[additional.tipo];

    if (config) {
      const introdujo = await Swal.fire({
        title: config.title,
        text: "",
        input: config.input,
        inputValue: config.getValue(),
        showCancelButton: true,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('swal.acep'),
        cancelButtonText: this.translate.instant('swal.cerr'),
        inputValidator: config.validator,
        reverseButtons: true,
        customClass: {
          actions: 'aleema-swal-actions',
          confirmButton: 'aleema-swal-confirm',
          cancelButton: 'aleema-swal-cancel',
          input: 'aleema-swal-select'
        },
      });

      if(guardo){
        messages.messageSaving(this.translate.instant('acciones.guardando'),this.translate.instant('acciones.espera'));
        switch(additional.tipo){
          case 'TEXT':
            var per =  this.getPeriod('numeros');
            const com = this.writeAditional(additional, activitie, true);
            if(!com && introdujo.value !== ''){
              try{
                const addic = {
                  activityId: activitie.id,
                  additionalId: Number(additional.id),
                  comentario: introdujo.value,
                  date: moment(per, 'MM-YYYY').format('YYYY-MM-DD'),
                };
                const res = await firstValueFrom(this.service.postAditionalActivity(addic));
                const act = this.activities.find(a => a.id === activitie.id);
                const add = act.adicionales.find(a => a.nombre === additional.nombre);
                if(add){
                  add.comentarios.push({
                    id: res['data'].comentarios[0].id,
                    comentario: introdujo.value,
                    date: moment(per, 'MM-YYYY').toISOString(),
                  });
                }else{
                  const adicionalPush = {
                    id: res['data'].id,
                    nombre: additional.nombre,
                    tipo: additional.tipo.toLowerCase(),
                    monto: res['data'].monto,
                    comentarios: [
                      {
                        id: res['data'].comentarios[0].id,
                        comentario: introdujo.value,
                        date: moment(per, 'MM-YYYY').toISOString(),
                      }
                    ],
                  }
                  act.adicionales.push(adicionalPush)
                }
              }catch(err){
                Swal.close();
                messages.errorMessageGraph(err);
                return;
              }

            }else{
              try{
                const ac = this.activities.find(a => a.id === activitie.id);
                const comA = this.writeAditional(additional, ac, true);
                const ad = ac.adicionales.find(a => a.nombre === additional.nombre)
                comA.comentario = introdujo.value;
                await firstValueFrom(this.service.patchAditionalActivityComentario(ad,comA));
              }catch(err){
                Swal.close();
                messages.errorMessageGraph(err);
                return;
              }

            }
            break;
          case 'FILE':
            const selectedFiles = introdujo.value;
            if( selectedFiles["size"] > obtenerTamMax.getPeso() ){
              messages.errorMessageGraph(obtenerTamMax.getTexto())
              this.editAditional(additional, activitie);
            }else{
              var per =  this.getPeriod('numeros');
              const fil = this.writeAditional(additional, activitie, true);
              const imageName = introdujo.value.name;
              if(!fil && introdujo.value !== ''){
                const addic = {
                  activityId: activitie.id,
                  additionalId: Number(additional.id),
                  file: selectedFiles,
                  date: moment(per, 'MM-YYYY').format('YYYY-MM-DD'),
                };
                const res = await firstValueFrom(this.service.postAditionalActivity(addic));
                const act = this.activities.find(a => a.id === activitie.id);
                const add = act.adicionales.find(a => a.nombre === additional.nombre);
                if(add){
                  add.archivos.push({
                    id: res['data'].archivos[0].id,
                    nombre: imageName,
                    date: moment(per, 'MM-YYYY').toISOString(),
                    s3key: res['data'].archivos[0].s3key,
                    type: res['data'].archivos[0].type,
                  });
                }else{
                  const adicionalPush = {
                    id: res['data'].id,
                    nombre: additional.nombre,
                    tipo: additional.tipo.toLowerCase(),
                    monto: res['data'].monto,
                    archivos: [
                      {
                        id: res['data'].archivos[0].id,
                        nombre: imageName,
                        date: moment(per, 'MM-YYYY').toISOString(),
                        s3key: res['data'].archivos[0].s3key,
                        type: res['data'].archivos[0].type,
                      }
                    ],
                  }
                  act.adicionales.push(adicionalPush)
                }
              }
            }
          break;
        }
        this.getShowProjects();
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('acciones.exito'));
      }
    }
  }
  public async openFile(file){
    try{
      const fil = await this.service.getFile(file.s3key);
      const link = document.createElement('a');
      link.href = fil;
      link.download = `${file.name}`; // opcional: puedes poner nombre
      link.target = '_blank'; // por si el navegador lo bloquea
      link.click();
    }catch(err){
      Swal.close();
      messages.errorMessageGraph(err);
      return;
    }
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito'));
  }
  public onContextMenu(event: MouseEvent, additional, activitie) {
    event.preventDefault();
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    const ac = this.activities.find(a => a.id === activitie.id);
    const comA = this.writeAditional(additional, ac, true);
    const ad = ac.adicionales.find(a => a.nombre === additional.nombre)
    this.adDelete = { file: comA, adicional:  ad, activitie};
    this.matMenuTrigger.openMenu();
  }
  public async deleteArchivo(){
    messages.messageSaving(this.translate.instant('acciones.deleting-item'),this.translate.instant('acciones.espera'));
    try{
      await firstValueFrom(this.service.deleteFile(this.adDelete.adicional, this.adDelete.file));
      const ac = this.activities.find(a => a.id === this.adDelete.activitie.id);
      const ad = ac.adicionales.find(a => a.nombre === this.adDelete.adicional.nombre)
      ad.archivos = ad.archivos.filter(f => f.id !== this.adDelete.file.id);
    }catch(err){
      Swal.close();
      messages.errorMessageGraph(err);
      return;
    }
    this.getShowProjects();
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('acciones.exito-delete'));
  }
}
